import { render, staticRenderFns } from "./List364.vue?vue&type=template&id=8c88c7f0"
import script from "./List364.vue?vue&type=script&lang=js"
export * from "./List364.vue?vue&type=script&lang=js"
import style0 from "./List364.vue?vue&type=style&index=0&id=8c88c7f0&prod&lang=css"
import style1 from "./List364.vue?vue&type=style&index=1&id=8c88c7f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports